import Cookies from "universal-cookie";
const cookies = new Cookies();

export const setUserAccessToken = (accessToken: string) => {
  cookies.set("at", accessToken, { path: "/", maxAge: 3600 });
};

export const getUserAccessToken = (): string | null => {
  const accessToken = cookies.get("at");
  return accessToken ? accessToken : null;
};
